import { usePricing } from "../hooks/usePricing";

/**
 * Price anchor — compares our live Stripe price against a truthful reference
 * (a studio video editor / professional service), not a fake "was" price.
 * This conveys value without misleading-pricing risk under Australian Consumer
 * Law / EU Omnibus / California FAL.
 *
 * Set VITE_LAUNCH_PRICING=1 to show the "Launch pricing" badge — flip off when
 * the launch period genuinely ends.
 */
export function PriceAnchor({
  compact = false,
  align = "start",
}: {
  compact?: boolean;
  align?: "start" | "center";
}) {
  const { display } = usePricing();
  const showLaunchBadge = import.meta.env.VITE_LAUNCH_PRICING === "1";
  const alignClass = align === "center" ? "items-center text-center" : "items-start";

  if (!showLaunchBadge) return null;

  if (compact) {
    return (
      <span
        className={`inline-flex items-center text-[10px] uppercase tracking-widest text-rose-700 font-medium ${
          align === "center" ? "text-center" : ""
        }`}
      >
        Launch pricing · limited time · {display}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center text-[11px] uppercase tracking-widest text-rose-700 font-medium ${alignClass}`}
    >
      Launch pricing · limited time · {display}
    </span>
  );
}
